import React from "react";
import styles from "./KPIDetailTile.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import closeIconLight from "../../../assets/images/LightTheme/close_icon_light.svg";
import closeIconDark from "../../../assets/images/DarkTheme/close_icon_dark.svg";

interface KPIDetailTileProps {
  headerContent?: React.ReactNode;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onClose: () => void;
  className?: string;
  dataTestId?: string;
}

const KPIDetailTile: React.FC<KPIDetailTileProps> = ({
  leftContent,
  rightContent,
  headerContent,
  onClose,
  className = "",
  dataTestId = "kpi-detail-tile",
}) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const closeIcon = currentTheme === "dark" ? closeIconDark : closeIconLight;

  if (!leftContent && !rightContent && !headerContent) {
    return null;
  }

  return (
    <div
      className={`${styles.detail_container} ${className}`}
      data-testid={dataTestId}
    >
      {/* Icon button to close the tile */}
      <div
        className={styles.close_icon}
        onClick={onClose}
        data-testid={`${dataTestId}-close`}
      >
        <img src={closeIcon} alt="x" />
      </div>

      {/* Header content (title, description and switchers) */}
       {headerContent && (
          <div
            className={styles.header_section}
            data-testid={`${dataTestId}-header`}
          >
            {headerContent}
          </div>
        )}


      {/* Left content (chart and tables area)*/}
        {leftContent && (
          <div
            className={styles.left_section}
            data-testid={`${dataTestId}-left`}
          >
            {leftContent}
          </div>
        )}

      {/* Right content (AI insights area)*/}
        {rightContent && (
          <div
            className={styles.right_section}
            data-testid={`${dataTestId}-right`}
          >
            {rightContent}
          </div>
        )}
      </div>
  );
};

export default KPIDetailTile;
